import { QueryClient } from "@tanstack/react-query";

/**
 * Singleton React Query client.
 *
 * Exported (rather than created inline in main.tsx) so non-component code — the
 * auth store — can clear it on identity changes. Query keys here are global
 * (not user-scoped), so the cache MUST be wiped when the authenticated PIC
 * changes; otherwise one user's commitment/runner data can bleed into the next
 * on a shared browser. See useAuthStore.setAuth/clearAuth.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000
    }
  }
});
